"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../../../api");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _FeedbackField = require("../../../FeedbackField");
var _ImageUpload = require("../../../ImageUpload");
var _Loading = require("../../../Loading");
var _RatingField = require("../../../RatingField");
var _TextField = require("../../../TextField");
var _Buttons = require("../Buttons");
var _Image = require("../Image");
var _ShadeInfo = require("../ShadeInfo");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const Content = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    productBrandName,
    productName
  } = (0, _api.useGetReview)();
  const {
    formState: {
      isSubmitSuccessful,
      isSubmitting
    }
  } = (0, _contexts.useRatingAndReviewForm)();
  const submitting = isSubmitting || isSubmitSuccessful;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [submitting ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_constants.CONTENT),
      display: "flex",
      flexDirection: "column",
      gap: 6,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        children: [productBrandName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Caption, {
          children: productBrandName
        }) : null, productName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          children: productName
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShadeInfo.ShadeInfo, {})]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RatingField.RatingField, {
        name: "score",
        starReviewDescriptions: (0, _react.useMemo)(() => [translations.clickOnStars, translations.oneStarReview, translations.twoStarReview, translations.threeStarReview, translations.fourStarReview, translations.fiveStarReview], [translations]),
        testId: getTestId(_constants.RATING)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.TextField, {
        required: true,
        name: "author",
        placeholder: translations.nameOrAliasPlaceholder,
        label: translations.nameOrAlias,
        type: "text",
        testId: getTestId(_constants.NAME_OR_ALIAS)
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.TextField, {
          multiline: true,
          name: "reviewText",
          placeholder: (0, _utils.parseProductReviewPlaceholder)(translations.productReviewPlaceholder),
          label: translations.productReview,
          type: "text",
          testId: getTestId(_constants.PRODUCT_REVIEW)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageUpload.ImageUpload, {})]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FeedbackField.FeedbackField, {
        addItemTitle: translations.addPro,
        feedbackItemStartIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {}),
        helperText: translations.prosHelperText,
        name: "pros",
        placeholder: translations.prosPlaceholder,
        removeItemTitle: translations.removePro,
        title: translations.pros,
        testId: getTestId(_constants.PROS)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FeedbackField.FeedbackField, {
        addItemTitle: translations.addCon,
        feedbackItemStartIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Remove, {}),
        helperText: translations.consHelperText,
        name: "cons",
        placeholder: translations.consPlaceholder,
        removeItemTitle: translations.removeCon,
        title: translations.cons,
        testId: getTestId(_constants.CONS)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Buttons.Buttons, {})]
    })]
  });
};
exports.Content = Content;
